import { render, staticRenderFns } from "./ContactBox.vue?vue&type=template&id=d18dc596&"
import script from "./ContactBox.js?vue&type=script&lang=js&"
export * from "./ContactBox.js?vue&type=script&lang=js&"
import style0 from "./ContactBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports